import axios from 'axios';
import {User} from '../../model/dto/userProfile/user';
import {UserPreferences} from '../../model/dto/userProfile/preferences';
import {UserInfo} from '../../model/dto/userProfile/userInfo';
import { BaseApi } from './BaseApi';
import AuthApi from './AuthApi';

export class UseApi extends BaseApi {
  token = '';
  static instance = new UseApi();

  constructor() {
    super();
    axios.defaults.headers.patch['Content-Type'] = 'application/json';
  }

  /**
   * Retrieves the user profile from the org dir.
   * @returns A user profile for the currently authenticated user.
   */
  getUser = async (): Promise<User> => {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/user`, {
        headers: {
          Authorization: `Bearer ${await AuthApi.getToken()}`,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          return response.data;
        }
      })
  };

}

export default UseApi.instance;
